import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { apiRequest } from '../reducers/data'

class _EulaContainer extends React.Component {
  static contextTypes = {
    router: () => {},
  }

  constructor(props) {
    super(props)
    this.state = { email: '', password: '', error: '', eula: false }
  }

  onSubmit = async (e) => {
    e.preventDefault()
    if (!this.state.eula) {
      this.setState({ error: 'Please accept the Terms and Policies to continue.' })
      return
    }
    const { json } = await this.props.dispatch(apiRequest(['eula'], 'POST', this.state))
    if (json.error) {
      this.setState({ error: json.error })
    } else {
      window.location.href = '/mobile/videos'
    }
  }

  render() {
    const { error, eula } = this.state

    return (
      <div
        className="screen sign-in"
        style={{
          background: `url(${require('../images/hex_background.jpg')})`,
          backgroundSize: 'cover',
        }}
      >
        <div>
          <form onSubmit={this.onSubmit} className="eula_form">
            <img className="logo" src={require('../images/logo.png')} alt="logo" />
            {error && <div className="error">{error}</div>}
            <h3>We've recently updated our Terms and Policies</h3>
            <p>
              In order to continue you must accept the updated{' '}
              <a
                target="_blank"
                href={`${process.env.REACT_APP_BASE_URL}/download/terms?external=true`}
              >
                Terms of Service
              </a>
              {/* ,{' '}
              <a
                target="_blank"
                href={`${process.env.REACT_APP_BASE_URL}/download/privacy-policy?external=true`} >
                Privacy Policy
              </a>{' '} */}
            </p>
            <div className="group">
              <input
                type="checkbox"
                id="eula"
                name="eula"
                checked={eula}
                style={{ width: '45px' }}
                onChange={(e) => this.setState({ eula: e.target.checked, error: '' })}
              />

              <label htmlFor="eula">I agree to the Terms of service.</label>
            </div>
            <button className="block" type="submit" disabled={!eula}>
              Accept
            </button>
          </form>
        </div>
      </div>
    )
  }
}

export default connect(() => {
  return {}
})(_EulaContainer)
